import React from "react";
import { Paper, Box, Typography, Link } from "@material-ui/core";
import { HeadsetMic as HeadsetIcon } from "@material-ui/icons";

import { AmbulancePhone as AmbulanceIcon } from "../Icons";

import { useStyles } from "../../hooks";
import styles from "./styles";

const PhoneBoxInfo = () => {
  const classes = useStyles(styles);

  return (
    <Paper className={classes.phoneBox} elevation={7}>
      <Box className={classes.boxBody}>
        <Box className={classes.ambulance}>
          <AmbulanceIcon className={classes.icon} />
        </Box>
        <Typography component="span" className={classes.text}>
          Si tenés alguna emergencia <br />
          comunicate al
          <br />
          <Link href="tel:0810-888-3226" color="primary" underline="none">
            0810-888-ECCO (3226)
          </Link>
        </Typography>
      </Box>
      <Box className={classes.boxFooter}>
        <HeadsetIcon fontSize="small" />
        <Typography component="span" className={classes.text}>
          Afiliaciones al{" "}
          <Link href="tel:0800-444-3226" color="inherit" underline="none">
            0800-444-3226
          </Link>
        </Typography>
      </Box>
    </Paper>
  );
};

export default PhoneBoxInfo;
